export default () => ({
    init() {
        const onKeyUp = (event) => {
            if (event.key === 'Escape') {
                this.$refs.input?.blur()
                this.$store.searchIsOpen = false
            }
        }

        document.addEventListener('keyup', onKeyUp)

        this.$watch('$store.searchIsOpen', (value) => {
            if (value) {
                this.$nextTick(() => this.$refs.input?.focus())
            }
        })
    },
})
